<script>

    import ArticleBase from "../Article/ArticleBase";
    import {mapActions, mapState} from "vuex";

    export default {
        name: 'cart-overview-item-base',
        extends: ArticleBase,
        props: ['cart', 'item'],
        data() {
            return {
                selectedColor: null,
                selectedSize: null
            };
        },
        created() {
            let variant = this.variantList.find(variation => {
                return variation.variationId === this.item.variantId;
            });

            this.selectedColor = variant.articleColor;
            this.selectedSize = variant.articleSize;

        },
        methods: {
            ...mapActions('cart', ['fetchCart', 'removeItem']),
            fetchArticleDetails() {
                return this.item.articleDetails;
            },
        },
        computed: {
            ...mapState("cart", ['busyItemId']),
            article: function () {
                return this.item.articleDetails;
            },
            articlePrice: function() {
                return this.item.articlePrice;
            },
            thumbnail: function () {
                let variant = this.variantList.find(variation => {
                    return variation.variationId === this.item.variantId;
                });

                let variantThumbnail = this.getThumbnail(variant.articleSize.id, variant.articleColor.id);
                return variantThumbnail ? variantThumbnail.media : (this.article.webImage || this.article.image);
            },
            category: function () {
                return this.item.category;
            },
            articleDetails: function () {
                return this.item.articleDetails;
            }
        },
    }
</script>
